import React, { useState } from 'react';
import MaharashtraMap from '../components/MaharashtraMap';
import Legend from '../components/Legend';
import { mineralsData, cropsData } from '../data/staticData';

export default function Home() {
  const [selectedContext, setSelectedContext] = useState({ district: null, region: null, minerals: [], crops: [] });

  const handleSelect = (payload) => {
    if (!payload) return setSelectedContext({ district: null, region: null, minerals: [], crops: [] });
    setSelectedContext({ district: payload.district || null, region: payload.region || null, minerals: payload.minerals || [], crops: payload.crops || [] });
  };

  return (
    <main className="container fade-in">
      {/* Hero */}
      <section className="apple-hero mb-6">
        <div className="flex-1">
          <h1 className="title">Discover Maharashtra — Minerals & Crops</h1>
          <p className="subtitle">Interactive map for students. Hover markers for quick facts and click to explore district details.</p>
          <div className="mt-6 flex gap-3">
            <button className="btn btn-primary">Explore Map</button>
            <button className="btn btn-ghost">How to use</button>
          </div>
        </div>
        <div className="w-80 glass-card hidden md:block">
          <div className="text-sm text-gray-600">Tip</div>
          <div className="mt-2 font-semibold">Hover markers to view mineral images. Click to open detailed card.</div>
        </div>
      </section>

      {/* Dashboard */}
      <section className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 map-card">
          <div className="map-card p-0">
            <MaharashtraMap onSelect={handleSelect} />
          </div>
        </div>

        <aside>
          <div className="card">
            <Legend minerals={mineralsData} crops={cropsData} selectedDistrict={selectedContext.district} selectedDetails={{ minerals: selectedContext.minerals, crops: selectedContext.crops, region: selectedContext.region }} />
          </div>
        </aside>
      </section>
      {/* Static Faizur image at end of page */}
      {/* <footer className="mt-2 text-center">
        <img
          src="/images/faizur.jpeg"
          alt="Faizur Rahman"
          className="w-[50px] h-[50px] object-cover rounded-full mx-auto ring-1 ring-gray-200 shadow-sm"
          onError={(e) => { e.currentTarget.style.display = 'none'; }}
        />
      </footer> */}
    </main>
  );
}
